import React from 'react';
import { useSelectState, SelectContext, } from './use-select-state.js';
import { SelectPopoverControlComponent } from './select-popover-control.component.js';
import { SelectPopoverContainerComponent } from './select-popover-container.component.js';
import { SelectLoadingComponent } from './select-loading.component.js';
import { SelectListBoxComponent } from './select-list-box.component.js';
import { SelectFilterInputComponent } from './select-filter-input.component.js';
import { SelectFieldComponent } from './select-field.component.js';
export const Select = React.forwardRef((props, forwardedRef) => {
    const selectState = useSelectState(props, forwardedRef);
    const SelectContextProvider = SelectContext.Provider;
    return (React.createElement(SelectContextProvider, { value: { selectState } },
        React.createElement(SelectFieldComponent, null,
            React.createElement(SelectPopoverControlComponent, null),
            React.createElement(SelectPopoverContainerComponent, null,
                React.createElement(SelectFilterInputComponent, null),
                React.createElement(SelectListBoxComponent, null),
                React.createElement(SelectLoadingComponent, null)))));
});
//# sourceMappingURL=select.component.js.map